import React from "react";
import { Card, CardBody, Col, Row, Table } from "reactstrap";
import { calcFailPct } from "./serviceUtils";

const ServiceKpiPanel = ({ kpi }) => {
    const { sales, swaps, returns, returnFails } = kpi;
    const returnFailPct = calcFailPct(returns, returnFails) + "%";

    const items = [
        { label: "Total sales",      value: sales,         color: "#2dce89" },
        { label: "Swaps",            value: swaps,         color: "#11cdef" },
        { label: "Returns",          value: returns,       color: "#2dce89" },
        { label: "Return Fails",     value: returnFails,   color: "#f5365c" },
        { label: "Return fail rate", value: returnFailPct, color: "#f5365c" },
    ];

    return (
        <Row className="mb-3">
            <Col xs="12">
                <Card>
                    <CardBody>
                        <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
                        <Table size="sm" className="mb-0" style={{ tableLayout: "auto", whiteSpace: "nowrap" }}>
                            <thead>
                                <tr>
                                    {items.map((item) => (
                                        <th key={item.label} className="text-center" style={{ fontSize: "1rem", fontWeight: 600, color: "#ffffff" }}>
                                            <span style={{ color: "#ffffff" }}>{item.label}</span>
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {items.map((item) => (
                                        <td key={item.label} className="text-center" style={{ fontSize: "1.4rem", fontWeight: 600 }}>
                                            <span style={item.color ? { color: item.color } : undefined}>{item.value}</span>
                                        </td>
                                    ))}
                                </tr>
                            </tbody>
                        </Table>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default ServiceKpiPanel;
